/**
 * The rail, in one place.
 *
 * Documents (Quotes, Invoices, Contracts, Questionnaires) each list their
 * documents with a New … button (29 Oct 2026).
 */

export interface NavItem {
  label: string
  to: string
  end?: boolean
  /** Other pages that belong under this item, for opening its menu section. */
  also?: string[]
}

export interface NavGroup {
  title: string
  /** Always open, with no drop-down (Operations and Personal HQ, 28 Oct 2026). */
  pinned?: boolean
  /** Other pages that count as this heading's (a linked heading only). */
  also?: string[]
  /** A heading that is a page of its own, with nothing under it (Contacts). */
  to?: string
  items: NavItem[]
}

/**
 * The order Jena set on 28 Oct 2026. Clicking a drop-down heading opens it
 * and goes to its first page.
 */
export const NAVIGATION: NavGroup[] = [
  {
    title: 'Operations',
    pinned: true,
    items: [
      { label: 'To do', to: '/todo' },
      { label: 'Projects', to: '/projects', also: ['/weddings', '/enquiries'] },
      { label: 'Calendar', to: '/calendar' },
      { label: 'Communications', to: '/communications' },
      { label: 'Editing', to: '/editing' },
    ],
  },
  { title: 'Contacts', to: '/contacts', items: [] },
  {
    title: 'Documents',
    items: [
      { label: 'Quotes', to: '/quotes' },
      { label: 'Invoices', to: '/invoices' },
      { label: 'Contracts', to: '/contracts' },
      { label: 'Questionnaires', to: '/questionnaires' },
    ],
  },
  {
    title: 'Delivery',
    items: [{ label: 'Galleries', to: '/galleries' }],
  },
  // Ads, Instagram and promotions, beside what they bring in (27 Oct 2026).
  {
    title: 'Marketing',
    items: [
      { label: 'Dashboard', to: '/marketing', end: true },
      { label: 'Feed planner', to: '/feed' },
      { label: 'Campaigns', to: '/marketing/campaigns' },
    ],
  },
  // Team, vendors and venues are databases she builds up, so they live in
  // Settings rather than in the daily menu (28 Oct 2026).
  // A heading of its own, like Contacts (29 Oct 2026). A person's page
  // (/team/<id>) belongs to it too.
  { title: 'Settings', to: '/settings', also: ['/team'], items: [] },
  // Life outside the business, kept apart from it (27 Oct 2026).
  {
    title: 'Personal HQ',
    pinned: true,
    items: [{ label: 'To do', to: '/personal' }],
  },
]
